import { Button } from '@/shadcn-ui/button';
import { cn } from '@/shadcn-ui/utils';
import { useState } from 'react';
import PromoCodeModal from './promo-code-drawer-dialog';
import PageBanner from '@/common/components/page-banner';
import HelpSmall from '@/icons/help-small';
import { colors } from '@/theme/colors';
import { PromoCodeReward } from '@/common/types/session';
import { BannerVariants } from '@/common/components/banner';
export type PromoCodeBannerProps = {
  promoCode: string;
  reward: PromoCodeReward;
  isSticky?: boolean;
  variant?: BannerVariants;
  ref?: React.RefObject<HTMLDivElement | null>;
  withBottomBorder?: boolean;
};

export default function PromoCodeBanner({
  promoCode,
  reward,
  isSticky,
  variant,
  ref,
  withBottomBorder = false,
}: PromoCodeBannerProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);

  return (
    <>
      <Button
        variant="clear"
        onClick={openModal}
        className={cn('h-auto w-full', {
          'border-b border-flexcar-neutral80': withBottomBorder,
        })}
      >
        <PageBanner ref={ref} isSticky={isSticky} variant={variant}>
          <div className={cn('flex items-center justify-center px-[36px]')}>
            <p className="body3">
              Promo code <b className="body3-strong">{promoCode}</b> applied successfully!
              <HelpSmall
                className="mb-[2px] ml-[8px] inline flex-shrink-0"
                fillPrimary={colors.neutral1}
              />
            </p>
          </div>
        </PageBanner>
      </Button>

      <PromoCodeModal
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        reward={reward}
      />
    </>
  );
}
